import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material"

import type { CsvDownloadFormat } from "types/csv.types"

interface CsvFormatPreferenceProps {
  value: CsvDownloadFormat
  onChange: (value: CsvDownloadFormat) => void
}

const CsvFormatPreference: FC<CsvFormatPreferenceProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {t("csv_drawer.FORMAT_PREFERENCES")}
      </Typography>
      <RadioGroup
        value={value}
        onChange={(e) => onChange(e.target.value as CsvDownloadFormat)}
        sx={{ alignItems: "flex-start" }}
      >
        <FormControlLabel
          value="zip"
          control={<Radio size="small" />}
          label={<Typography variant="body2">{t("csv_drawer.FORMAT_ZIP")}</Typography>}
        />
        <FormControlLabel
          value="separate"
          control={<Radio size="small" />}
          label={
            <Typography variant="body2">{t("csv_drawer.FORMAT_SEPARATE")}</Typography>
          }
        />
      </RadioGroup>
    </Stack>
  )
}

export default CsvFormatPreference
